import React from 'react';

function PipeBioTokenSection(): JSX.Element {
  return (
    <>
      <h3>Tokens</h3>
      <table className="table table-striped pipebio-token-table hidden">
        <thead>
          <tr>
            <th>Account Token</th>
            <th />
            <th />
            <th>Created At</th>
            <th />
          </tr>
        </thead>
        <tbody className="pipebio-tokens" />
      </table>
      <button type="button" className="button button--tertiaryGray button--medium js-generate-pipebio-token">
        Generate New PipeBio Account Token
      </button>
    </>
  );
}

export default function ProfilePipeBioIntegrationSettings(): JSX.Element {
  return (
    <>
      <h2>PipeBio Integration</h2>
      <PipeBioTokenSection />
      <h3>Information</h3>
      <div>
        Copy this token into your PipeBio profile so actions you take in PipeBio can be linked to this
        Benchling account.{' '}
        <a
          title="PipeBio token documentation"
          href="" // TODO: add link
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn more
        </a>
        .
      </div>
    </>
  );
}
